module.exports = __webpack_public_path__ + "img/小雨农智.5e290512.png";